import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4.432 4.442a3 3 0 1 0 4.114 4.146","key":"svg-0"}],["path",{"d":"M3 17a3 3 0 1 0 6 0a3 3 0 1 0 -6 0","key":"svg-1"}],["path",{"d":"M8.6 15.4l3.4 -3.4m2 -2l5 -5","key":"svg-2"}],["path",{"d":"M3 3l18 18","key":"svg-3"}]]

const IconScissorsOff = createReactComponent('outline', 'scissors-off', 'ScissorsOff', __iconNode);

export default IconScissorsOff;